<template>
    <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12 xl12 style="padding:19px;padding-bottom:0px !important;padding-top:22px !important">
            <div style="padding-top:0px;font-weight:bolder;font-size:17px;padding-bottom:5px;">تنظیمات سئو</div>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;padding-top:0px">
            <v-layout row wrap>
                <v-flex xs12 sm12 md5 lg5 xl5 style="padding:15px;padding-top:0px">
                    <v-text-field color="#2a2d45" @keydown="EmitData" v-model="SeoData.title" outlined dense label="عنوان (Title)"></v-text-field>
                    <v-text-field color="#2a2d45" @keydown="EmitData" v-model="SeoData.url" outlined dense label="آدرس(Url) "></v-text-field>
                    <v-combobox
                    dense
                    multiple
                   v-model="videoKeyWords"
                    outlined
                    clearable
                    chips
                    append-icon="fas fa-a"
                    deletable-chips
                    class="tag-input"
                    label="کلید واژه ها (Keywords)"
                    color="#2a2d45"
                    @keydown="EmitData"
                    :search-input.sync="videoKeyWordSearch"
                    @keyup.tab="updateVideoKeyWords"
                    @paste="updateVideoKeyWords"
                    @blur="EmitData"
                    ></v-combobox>
                    <f-up :hideExternal="false" :OldFile="SeoData.image" @RetunedFileName="retunedImageName" Root="ESEO" :Folder="FileLoc" BtnTitle="لوگو"></f-up>
                  
                </v-flex>
                <v-flex xs12 sm12 md7 lg7 xl7 style="padding:15px;padding-top:0px">
                    <v-textarea color="#2a2d45" @keydown="EmitData" v-model="SeoData.description" outlined dense label="توضیحات (Description)"></v-textarea>
                    <v-textarea color="#2a2d45" @keydown="EmitData" v-model="SeoData.othermeta" outlined dense label="Other Meta Tags"></v-textarea>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>
<script>
const axios = require("axios");
const ApiUrl = require('../../constant/apiurl');
const MSGHNDL = require('../../constant/MessageHandler');
const FTYPES = require('../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../constant/setting/Default/AllowedFileSize');
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    name:"seo",
    props:{FileLoc:{type:String},Seo:{type:Object}},
    data:()=>({
        SeoImage:require('../../assets/logo.png'),
        OriginalSelectedImage:"",
        SeoImageSelectionDialog:false,
        SeoData:{title:"",
      url:"",
      keywords:"",
      image:"",
      description:"",
      othermeta:""},
      videoKeyWords:[],
      videoKeyWordSearch:""
    }),
    created()
    {
        this.ChangeSeoContent(this.Seo);
        // this.SeoData = this.Seo;
    },
    mounted(){
        // this.loadData();
    },
    watch:{
        Seo:function(v,ov){
            console.warn("New value : ",v,"Old value : ",ov);
           let vm = this;
            v.image = (v.image != null && typeof(v.image) != typeof(undefined)) ? ApiUrl.SeoUrl+this.FileLoc+"/"+v.image: null;
            vm.videoKeyWords = (v.keywords != "" && v.keywords != null) ? v.keywords.split(',') : [];
            this.SeoData = v;
            console.warn("PASSED DATA : ",v);
            setTimeout(() => {
                vm.EmitData();
            }, 1000);
        }
       
    },
    methods:{
        ChangeSeoContent(v)
        {
            let vm = this;
            v.image = (v.image != null && typeof(v.image) != typeof(undefined)) ? ApiUrl.SeoUrl+this.FileLoc+"/"+v.image: null;
            vm.videoKeyWords = (v.keywords != "" && v.keywords != null) ? v.keywords.split(',') : [];
            this.SeoData = v;
            console.warn("PASSED DATA : ",v);
            setTimeout(() => {
                vm.EmitData();
            }, 1000);
        },
        updateVideoKeyWords() {
            let vm = this;
            this.$nextTick(() => {

                this.videoKeyWords.push(...this.videoKeyWordSearch.split(","));
                this.$nextTick(() => {
                this.videoKeyWordSearch = "";
                vm.EmitData();
                });
                vm.EmitData();
            });
            vm.EmitData();
        },
        // ...mapActions([                  // Add this
        // 'setSeoForm'
        // ]),
        loadData()
        {
            let vm = this;
            setTimeout(() => {
                vm.Seo = vm.$store.getters.getSeoForm;
                vm.videoKeyWords = (vm.SeoData.keywords != null) ? vm.SeoData.keywords.split(',') : [];
                vm.SeoData.image = ApiUrl.SeoUrl+vm.FileLoc+"/"+vm.SeoData.image;
            }, 1500);
        },
        async EmitData()
        {
            let vm = this;
            let data = this.SeoData;
            data.keywords = (vm.videoKeyWords.length > 0)?vm.videoKeyWords.join(','):"";
            let split = (data.image != null && typeof(data.image) != typeof(undefined)) ? data.image.split('/'):[];
            if(data.url != "" && typeof(data.url) != undefined && data.url != null)
            {
                let splitUrl = data.url.split(' ');
                data.url = splitUrl.join('-');
            }
            
            data.image = split[split.length - 1];
            vm.$emit('SeoData',data)
        },
        retunedImageName(img)
        {
            this.SeoData.image = img;
            this.EmitData();
        },
        
      
    }
}
function SeoStruture(data) {
    this.title = data.title;
    this.url = data.url;
    this.keywords = data.keywords;
    this.image = data.image;
    this.description = data.description;
    this.othermeta = data.othermeta;
}
</script>